import React from 'react';
import { MapPin, Instagram } from 'lucide-react';
export function VisitHours() {
  return <section id="visit" className="py-24 bg-brand-dark text-white" data-id="element-109">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-110">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 lg:gap-16" data-id="element-111">
          {/* Column 1: Find Us */}
          <div data-id="element-112">
            <span className="inline-block font-display font-bold text-brand-gold tracking-widest uppercase text-sm mb-3" data-id="element-113">
              Find Us
            </span>
            <h2 className="font-display font-extrabold text-white text-4xl mb-8 uppercase" data-id="element-114">
              Explore Our Marketplace
            </h2>

            <div className="mb-6" data-id="element-115">
              <div className="font-display font-extrabold text-2xl uppercase text-brand-cream mb-1" data-id="element-116">
                Market on 8th
              </div>
              <address className="not-italic text-brand-cream/80 text-base leading-relaxed mb-4" data-id="element-117">
                41 E. 8th St.
                <br data-id="element-118" />
                National City, CA 91950
              </address>
              <a href="tel:6198564538" className="text-brand-gold hover:text-brand-yellow font-bold text-lg transition-colors" data-id="element-119">
                (619) 856-4538
              </a>
            </div>

            <div className="flex flex-col gap-3 mt-8" data-id="element-120">
              <a href="https://maps.app.goo.gl/2Q6LZT6rFPQtYsny5" target="_blank" rel="noopener noreferrer" className="flex items-center justify-center gap-2 bg-brand-orange hover:bg-brand-coral text-white px-6 py-3 rounded-none font-bold transition-all text-sm w-full sm:w-fit uppercase tracking-wider" data-id="element-121">
                <MapPin size={16} strokeWidth={2.5} data-id="element-122" />
                Open in Google Maps
              </a>
              <a href="https://www.instagram.com/marketon8thst/" target="_blank" rel="noopener noreferrer" className="flex items-center justify-center gap-2 bg-transparent border border-white/30 hover:bg-white/10 text-white px-6 py-3 rounded-none font-bold transition-all text-sm w-full sm:w-fit uppercase tracking-wider" data-id="element-123">
                <Instagram size={16} strokeWidth={2} data-id="element-124" />
                Instagram
              </a>
            </div>
          </div>

          {/* Column 2: Building Hours */}
          <div id="hours" data-id="element-125">
            <h3 className="font-display font-bold text-xl uppercase tracking-wider text-brand-cream/50 mb-6 border-b border-white/10 pb-4" data-id="element-126">
              Building Hours
            </h3>
            <div className="space-y-1" data-id="element-127">
              <div className="flex justify-between py-2 px-2" data-id="element-128">
                <span className="font-semibold text-brand-cream/90" data-id="element-129">
                  Sunday
                </span>
                <span className="text-brand-cream/70" data-id="element-130">8 AM – 10 PM</span>
              </div>
              <div className="flex justify-between py-2 px-2 bg-brand-orange/10 rounded-md border-l-2 border-brand-coral" data-id="element-131">
                <span className="font-bold text-brand-coral" data-id="element-132">Monday</span>
                <span className="font-bold text-white" data-id="element-133">8 AM – 10 PM</span>
              </div>
              <div className="flex justify-between py-2 px-2" data-id="element-134">
                <span className="font-semibold text-brand-cream/90" data-id="element-135">
                  Tuesday
                </span>
                <span className="text-brand-cream/70" data-id="element-136">8 AM – 10 PM</span>
              </div>
              <div className="flex justify-between py-2 px-2" data-id="element-137">
                <span className="font-semibold text-brand-cream/90" data-id="element-138">
                  Wednesday
                </span>
                <span className="text-brand-cream/70" data-id="element-139">8 AM – 10 PM</span>
              </div>
              <div className="flex justify-between py-2 px-2" data-id="element-140">
                <span className="font-semibold text-brand-cream/90" data-id="element-141">
                  Thursday
                </span>
                <span className="text-brand-cream/70" data-id="element-142">8 AM – 10 PM</span>
              </div>
              <div className="flex justify-between py-2 px-2" data-id="element-143">
                <span className="font-semibold text-brand-cream/90" data-id="element-144">
                  Friday
                </span>
                <span className="text-brand-cream/70" data-id="element-145">8 AM – 10 PM</span>
              </div>
              <div className="flex justify-between py-2 px-2" data-id="element-146">
                <span className="font-semibold text-brand-cream/90" data-id="element-147">
                  Saturday
                </span>
                <span className="text-brand-cream/70" data-id="element-148">8 AM – 10 PM</span>
              </div>
            </div>
          </div>

          {/* Column 3: Kitchen Hours */}
          <div data-id="element-149">
            <h3 className="font-display font-bold text-xl uppercase tracking-wider text-brand-cream/50 mb-6 border-b border-white/10 pb-4" data-id="element-150">
              Kitchen Hours
            </h3>
            <div className="space-y-3 mb-6" data-id="element-151">
              <div className="flex justify-between items-center border-b border-white/5 pb-2" data-id="element-152">
                <span className="font-semibold text-brand-cream/90" data-id="element-153">
                  Coleta
                </span>
                <span className="text-brand-cream/70 text-sm" data-id="element-154">8 AM – 3 PM</span>
              </div>
              <div className="flex justify-between items-center border-b border-white/5 pb-2" data-id="element-155">
                <span className="font-semibold text-brand-cream/90" data-id="element-156">
                  Alessie
                </span>
                <span className="text-brand-cream/70 text-sm" data-id="element-157">8 AM – 5 PM</span>
              </div>
              <div className="flex justify-between items-center border-b border-white/5 pb-2" data-id="element-158">
                <span className="font-semibold text-brand-cream/90" data-id="element-159">
                  Barra 8
                </span>
                <span className="text-brand-cream/70 text-sm" data-id="element-160">
                  12 PM – 10 PM
                </span>
              </div>
              <div className="flex justify-between items-center border-b border-white/5 pb-2" data-id="element-161">
                <span className="font-semibold text-brand-cream/90" data-id="element-162">
                  Ping Yang
                </span>
                <span className="text-brand-cream/70 text-sm" data-id="element-163">
                  11 AM – 9 PM
                </span>
              </div>
              <div className="flex justify-between items-center border-b border-white/5 pb-2" data-id="element-164">
                <span className="font-semibold text-brand-cream/90" data-id="element-165">
                  Carnitas Quiroga
                </span>
                <span className="text-brand-cream/70 text-sm" data-id="element-166">
                  11 AM – 7 PM
                </span>
              </div>
              <div className="flex justify-between items-center border-b border-white/5 pb-2" data-id="element-167">
                <span className="font-semibold text-brand-cream/90" data-id="element-168">
                  Other Kitchens
                </span>
                <span className="text-brand-cream/70 text-sm" data-id="element-169">
                  12 PM – 9 PM
                </span>
              </div>
            </div>
            <p className="text-xs text-brand-cream/40 italic mb-8" data-id="element-170">
              * Hours may change at vendor's discretion.
            </p>

            {/* Callout */}
            <div className="bg-brand-gold/10 border-l-4 border-brand-gold p-5 rounded-r-lg" data-id="element-171">
              <div className="font-display font-extrabold text-xl uppercase text-brand-gold mb-2" data-id="element-172">
                Open 7 Days a Week
              </div>
              <p className="text-sm text-brand-cream/70 leading-relaxed" data-id="element-173">
                We're here every day of the year to serve the National City
                community. Come as you are.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}